import Pet from '~models/pet'
import api from '~utils/http'

class PetRepositoryImpl {
  async createPet(draft: Pet.ILevel1) {
    return new Pet.Level1(
      (
        await api.post<Pet.ILevel1>(
          '/app/pets/',
          {
            ...draft,
            born_at: new Date(draft.born_at || 0).toISOString(),
            born_year: new Date(draft.born_at || 0).getFullYear(),
          },
          {
            withCredentials: true,
          }
        )
      ).data
    )
  }

  async updatePet(pet: Pet.Level1) {
    return (
      await api.patch<Pet.Level1>(
        `/app/pets/${pet.id}/`,
        {
          ...pet,
          born_at: new Date(pet.born_at || 0).toISOString(),
          born_year: new Date(pet.born_at || 0).getFullYear(),
        },
        {
          withCredentials: true,
        }
      )
    ).data
  }
}

const PetRepository = new PetRepositoryImpl()
export default PetRepository
